import * as React from 'react';
function SvgCheckPaymentGive(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="check-payment-give_svg__fil-icon"
      {...props}
    >
      <path d="M15.75 18v.75A2.25 2.25 0 0113.5 21H3.75a3 3 0 01-2.684-1.658M3.75 15h1.5a3 3 0 003-3h2.25a2.25 2.25 0 000-4.5H3.75a3 3 0 00-3 3" />
      <path d="M5.25 7.5v-3A1.5 1.5 0 016.75 3h15a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5h-12m9 0a3 3 0 01-3 3h-6M15.75 7.5h7.5M17.25 10.5h3" />
    </svg>
  );
}
export default SvgCheckPaymentGive;
